<p class="uppercase">
  <a class ="underline" href="/progetti">> Progetti </a> > {{progetto?.nome}}
<p>
  <!-- PROGETTO-->
<div *ngIf="progetto" style="background-color: {{_bgColor}}" class="py-8 px-8 bg-white rounded-xl shadow-lg w-full">
  <div *ngIf="lastEd" class="inline-grid grid-cols-3 gap-1">
    <div class="block">
      <img class="rounded-md sm:mx-0 sm:shrink-0 h-32 m-auto py-3 px-3" [src]="apiUrl+'/assets/'+progetto.immagine"
        alt="" style="background-color: {{progetto.colore}}">
    </div>
    <div class="block">
      <div class="text-center w-full">
        <p class="text-lg ">
          Ultima edizione:<br><span class="my-1 font-semibold text-black">{{lastEd.nome}}</span>
        </p>
        <ul>
          <li class="my-1">{{lastEd.getEditionDate()}}</li>
          <!-- li><span>id:</span>{{lastEd.id}}</!-->
          <!-- li><span>stato:</span>{{lastEd.status}}</!-->
          <!-- li><span>nome:</span>{{lastEd.nome}}</!-->
          <li class="my-1">{{lastEd.descrizione}}</li>
          <!-- li><span>progetto:</span>{{lastEd.progetto}}</!-->
          <li class="my-1"><a href="{{progetto.website}}" target="_blank" class="text-purple-600 font-semibold hover:text-primary hover:primary hover:border-transparent">{{progetto.website}}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="block">
      <div class="text-center">
        <span>badge:</span><img class="m-auto h-44 w-auto object-scale-down" src="{{apiUrl}}/assets/{{lastEd.badge}}?width=300">
        <!-- app-canvas-badge edizione_id="{{lastEd.id}}" (open())="open()"></!-->
      </div>
    </div>
  </div>
</div>
<div class="block relative -top-8 w-4">
  <button (click)="nuovaEdizione()" class="plus w-3" alt="nuova edizione" title="nuova edizione">
    <svg xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
      <path
        d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM232 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z" />
    </svg>
  </button>
</div>
<!-- EDIZIONI-->
<div class="w-full text-center p-8" *ngIf="!lastEd">
  <p class="space-y-0.5">nessuna edizione</p>
</div>
<!-- TOOLBAR -->
<div class="w-full text-left p-1">
  <ul class="inline-flex">
    <li role="button" class="cursor-pointer mx-4 my-2">
      <fa-icon class="text-testo svg-faButton" [ngClass]="{'hidden': layoutGrid}" [icon]="faTh"
        (click)="changeLayout($event.target)"></fa-icon>
      <fa-icon class="text-testo svg-faButton" [ngClass]="{'hidden': !layoutGrid}" [icon]="faList"
        (click)="changeLayout($event.target)"></fa-icon>
    </li>
  </ul>
</div>
<div *ngIf="lastEd" class="bg-white" [ngClass]="{'gridL': layoutGrid}">
  <div *ngFor="let edizione of edizioni"
    class="text-slate-800 items-center rounded-md p-3 transition-all hover:bg-slate-100 focus:bg-slate-100 active:bg-slate-100 w-full">
    <div>
      <!-- p>{{edizione.id}}</!-- -->
      <div class="p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700">
        <div class="inline-grid grid-cols-3 gap-4 w-full">
          <div class="block  col-span-2">
            <h5 class="mb-2 text-xl font-semibold tracking-tight text-gray-900 dark:text-white">ed {{edizione.fine}} -
              {{edizione.nome}}
            </h5>
            <p class="my-1" *ngIf="edizione.iscrizioni">
              iscritti: {{edizione.iscrizioni}} <span *ngIf="edizione.confermati >0 "> - confermati: {{edizione.confermati}}</span>
              <span *ngIf="edizione.presenti >0 ">
                - presenti: {{edizione.presenti}}</span>
            </p>
            <p class="mb-3 font-normal text-gray-500 dark:text-gray-400">
              {{getEditionDate(edizione)}}
            </p>
            <p *ngIf="edizione.descrizione" class="mb-3 font-normal text-gray-500 dark:text-gray-400">
              {{edizione.descrizione}}
            </p>
            <p class="ml-0 mt-2 inline-block">
              <fa-icon alt="apri edizione" title="apri edizione" class="cursor-pointer pr-2 text-testo" [icon]="faEye" (click)="goToEdizione(edizione.id)" role="button"></fa-icon>
              <fa-icon alt="modifica edizione" title="modifica edizione" class="cursor-pointerpx-2 text-testo" [icon]="faPencil" (click)="openEdizione(edizione)" role="button"></fa-icon>
            </p>
          </div>
          <div class="block text-right">
            <img class=" inline-block h-32 w-auto object-scale-down" src="{{apiUrl}}/assets/{{edizione.badge}}?width=100">
            <fa-icon class="px-2 text-xl text-testo" [icon]="faPencil" (click)="editBadge(edizione)" role="button"></fa-icon>
          </div>
        </div>
      </div>
      <div class="block relative -top-4 w-4 text-right w-full">
        <button (click)="deleteEdizione(edizione)" class="w-8" alt="cancella edizione" title="cancella edizione">
          <svg xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.-->
            <path fill="#000000"
              d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 232l144 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-144 0c-13.3 0-24-10.7-24-24s10.7-24 24-24z" />
          </svg>
        </button>
      </div>
    </div>
  </div>
</div>
<!-- MODAL EDIZIONE-->
<div *ngIf="isModalOpen"
  class="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div
    class="relative p w-full sm:max-w-xl md:max-w-4xl bg-white rounded-lg shadow dark:bg-gray-700 max-h-[90vh] overflow-y-auto mx-4 md:mx-0">
    <!-- Modal header -->
    <div class="sticky top-0 flex items-center justify-between p-4 border-b rounded-t bg-white dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        <span *ngIf="!isCurrentEdizione()">Nuova Edizione</span>
        <span *ngIf="isCurrentEdizione()">Modifica edizione</span>
      </h3>
      <button (click)="closeModal()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
        <!-- Close SVG -->
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Modal body -->
    <div class="text-center w-full">
      <div *ngIf="isCurrentEdizione()" class="text-center">
        <app-canvas-badge #badge_component edizione_id="{{_currentEd.id}}"></app-canvas-badge>
      </div>
      <form class="text-center w-full max-w-md sm:max-w-xl md:max-w-2xl my-10 space-y-6 inline-block "
        [formGroup]="form" (ngSubmit)="onSubmit()">
        <div class="form__group">
          <div class="md:flex md:items-center mb-6" style="display: none;">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="status">
                stato
              </label>
            </div>
            <div class="md:w-4/5 text-center">
              <label>
                <input type="radio" value="0" formControlName="status">
                <span class="pr-4"> chiusa</span>
              </label>
              <label>
                <input type="radio" value="1" formControlName="status">
                <span class="pr-4"> aperta</span>
              </label>
            </div>
            <div *ngIf="submitted && f['status'].errors" class="is__invalid-error">
              <div *ngIf="f['status'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="preview-image"
            *ngIf="imagePreview !== '' && imagePreview && form.get('badge').valid && !isCurrentEdizione()">
            <img [src]="imagePreview" [alt]="form.value.title">
          </div>
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Badge<span *ngIf="!isCurrentEdizione()">*</span>
              </label>
            </div>
            <div class="md:w-4/5">
              <input type="file" #badgeLoader name="badgeLoader" (change)="onSelectBadge($event)" id="badge"
                [ngClass]="{ 'is__invalid-input': submitted && f['badge'].errors }" formControlName="badge" class=""
                placeholder="carica il badge">
            </div>
            <div *ngIf="submitted && f['badge'].errors" class="is__invalid-error">
              <div *ngIf="f['badge'].errors['required']">Campo richiesto</div>
            </div>
            <div *ngIf="badge.errors?.['requiredFileType']" class="filed-invalid">
              <span>Sono permessi solamente files .{{validExt}}</span>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Titolo*
              </label>
            </div>
            <div class="md:w-4/5">
              <input type="text" id="nome" [ngClass]="{ 'is__invalid-input': submitted && f['nome'].errors }"
                placeholder=" " formControlName="nome"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci il titolo" formControlName="nome">
            </div>
            <div *ngIf="submitted && f['nome'].errors" class="is__invalid-error">
              <div *ngIf="f['nome'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="inizio">
                Inizio*
              </label>
            </div>
            <div class="md:w-4/5">
              <input type="datetime-local" id="inizio"
                [ngClass]="{ 'is__invalid-input': submitted && f['inizio'].errors }" placeholder=" "
                formControlName="inizio"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci l'e-mail" formControlName="inizio">
            </div>
            <div *ngIf="submitted && f['inizio'].errors" class="is__invalid-error">
              <div *ngIf="f['inizio'].errors['required']">Campo richiesto</div>
              <div *ngIf="f['inizio'].errors['inizio']">L'e-mail deve essere un indirizzo valido.</div>
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Fine*
              </label>
            </div>
            <div class="md:w-4/5">
              <input type="datetime-local" id="fine" [ngClass]="{ 'is__invalid-input': submitted && f['fine'].errors }"
                placeholder=" " formControlName="fine"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci il fine" formControlName="fine">
            </div>
          </div>
        </div>
        <div class="form__group">
          <div class="md:flex md:items-center mb-6">
            <div class="md:w-1/5">
              <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                Descrizione
              </label>
            </div>
            <div class="md:w-4/5">
              <input type="text" id="descrizione"
                [ngClass]="{ 'is__invalid-input': submitted && f['descrizione'].errors }" placeholder=" "
                formControlName="descrizione"
                class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                placeholder="inserisci l'descrizione" formControlName="descrizione">
            </div>
            <div *ngIf="submitted && f['descrizione'].errors" class="is__invalid-error">
              <div *ngIf="f['descrizione'].errors['required']">Campo richiesto</div>
            </div>
          </div>
        </div>

        <!-- BOTTONI -->
        <div class="inline-grid grid-cols-2 gap-2 w-full">
          <div class="text-center md:items-center">
            <button [hidden]="form.invalid" impact="bold" tone="primary" shape="rounded" size="medium"
              class="shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded">
              <span *ngIf="!isCurrentEdizione()">Salva</span>
              <span *ngIf="isCurrentEdizione()">Aggiorna</span>
            </button>
          </div>
          <div class="text-center md:items-center">
            <button (click)="closeModal()" impact="bold" tone="primary" shape="rounded" size="medium"
              class="shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded">
              Annulla
            </button>
          </div>
        </div>
      </form>
    </div>
    <div class="text-center text-sm color-warning">{{print_error}}</div>
  </div>
</div>
<!-- MODAL BADGE-->
<div *ngIf="isModalBadgeOpen"
  class="fixed top-0 left-0 right-0 bottom-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-50">
  <div
    class="relative p w-full sm:max-w-xl md:max-w-4xl bg-white rounded-lg shadow dark:bg-gray-700 max-h-[90vh] overflow-y-auto mx-4 md:mx-0">
    <!-- Modal header -->
    <div class="sticky top-0 flex items-center justify-between p-4 border-b rounded-t bg-white dark:border-gray-600">
      <h3 class="text-xl font-semibold text-gray-900 dark:text-white">
        <span>Modifica Badge</span>
      </h3>
      <button (click)="closeModalBadge()"
        class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
        <svg class="w-6 h-6" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
          <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
        </svg>
        <span class="sr-only">Close modal</span>
      </button>
    </div>
    <!-- Modal body -->
    <div class="text-center w-full">
      <div class="inline-grid grid-cols-1 md:grid-cols-2 l:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2  gap-4 w-full">
        <div *ngIf="isCurrentEdizione()" class="text-center my-10 ">
          <app-canvas-badge #badge_componentBadge edizione_id="{{_currentEd.id}}"></app-canvas-badge>
        </div>
        <div>
          <form class="text-center max-w-md sm:max-w-xl md:max-w-2xl my-10 space-y-3 inline-grid grid-cols-1 md:grid-cols-2 l:grid-cols-2 xl:grid-cols-2 2xl:grid-cols-2 gap-4 w-full "
            [formGroup]="formBadge" (ngSubmit)="onSubmitBadge()">
            <div class="form__group form_badge mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Dim. Font
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="b_font_size"
                    [ngClass]="{ 'is__invalid-input': submitted && fb['b_font_size'].errors }" placeholder=" "
                    formControlName="b_font_size"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la dimensione del testo" formControlName="b_font_size">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="inizio">
                    Largh.za badge
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="bw" [ngClass]="{ 'is__invalid-input': submitted && fb['bw'].errors }"
                    placeholder=" " formControlName="bw"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la larghezza del badge" formControlName="bw">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Alt.za badge
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="bh" [ngClass]="{ 'is__invalid-input': submitted && fb['bh'].errors }"
                    placeholder=" " formControlName="bh"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci l'altezza del badge" formControlName="bh">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Pos. X testo
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="tx" [ngClass]="{ 'is__invalid-input': submitted && fb['tx'].errors }"
                    placeholder=" " formControlName="tx"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la posizione del testo sull'asse x" formControlName="tx">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Pos. Y testo
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="ty" [ngClass]="{ 'is__invalid-input': submitted && fb['ty'].errors }"
                    placeholder=" " formControlName="ty"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la posizione del testo sull'asse y" formControlName="ty">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Largh.za Qrcode
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="qrcode_w" (change)="onChangeQrW($event)"
                    [ngClass]="{ 'is__invalid-input': submitted && fb['qrcode_w'].errors }" placeholder=" "
                    formControlName="qrcode_w"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la larghezza del Qrcode" formControlName="qrcode_w">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Alt.za Qrcode
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="qrcode_h" (change)="onChangeQrH($event)"
                    [ngClass]="{ 'is__invalid-input': submitted && fb['qrcode_h'].errors }" placeholder=" "
                    formControlName="qrcode_h"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci l'altezza del Qrcode" formControlName="qrcode_h">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Pos. X Qrcode
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="qrcode_x"
                    [ngClass]="{ 'is__invalid-input': submitted && fb['qrcode_x'].errors }" placeholder=" "
                    formControlName="qrcode_x"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la posizione del Qrcode sull'asse x" formControlName="qrcode_x">
                </div>
              </div>
            </div>
            <div class="form__group mt-0">
              <div class="md:flex md:items-center mb-6">
                <div class="md:w-2/5">
                  <label class="block font-bold md:text-right mb-1 md:mb-0 pr-4" for="nome">
                    Pos. Y Qrcode
                  </label>
                </div>
                <div class="md:w-3/5">
                  <input type="text" id="qrcode_y" (change)="onChangeQrY($event)"
                    [ngClass]="{ 'is__invalid-input': submitted && fb['qrcode_y'].errors }" placeholder=" "
                    formControlName="qrcode_y"
                    class="bg-gray-50 appearance-none border-2 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none focus:bg-white focus:border-purple-500"
                    placeholder="inserisci la posizione del Qrcode sull'asse x" formControlName="qrcode_y">
                </div>
              </div>
            </div>

            <!-- BOTTONI -->
             <div>&nbsp;</div>
            <div class="inline-grid grid-cols-2 gap-2 w-full">
              <div class="text-center md:items-center">
                <button [hidden]="formBadge.invalid" impact="bold" tone="primary" shape="rounded" size="medium"
                  class="shadow focus:shadow-outline focus:outline-none font-bold py-2 px-4 rounded">
                  <span *ngIf="isCurrentEdizione()">Aggiorna</span>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="text-center text-sm color-warning">{{print_error}}</div>
  </div>
</div>
